import { parsePhoneNumberFromString } from "libphonenumber-js";

export const phoneTest = (defaultCountry = "GB") => ({
    name: "is-valid-phone",
    message: "Phone number is an invalid UK number",
    test: (value) => {
        if (!value) return false; // required check
        try {
            const phoneNumber = parsePhoneNumberFromString(
                value,
                defaultCountry,
            );
            return phoneNumber?.isValid() ?? false;
        } catch {
            return false;
        }
    },
});
